import { getApolloClient } from "./lib/apollo";
import { CurrentUserQuery } from "gql/current_user.graphql";
import {
  initAnalytics,
  identifyUser,
  resetAnalytics,
  hasIdentifiedUser,
  consumeLoginBeacon,
  trackSignedIn,
  trackPageView
} from "./lib/analytics";

initAnalytics();

// The beacon cookie is set by the Warden hook on every genuine sign-in and the
// page that follows login is always a full load, so this runs exactly once per
// login. Reset first (shared-machine hygiene), then track immediately against
// the fresh anonymous id — simplified ID merge folds it into the user once
// identify() fires below, and a failed CurrentUserQuery can't lose the event.
const loginMethod = consumeLoginBeacon();
if (loginMethod) {
  resetAnalytics();
  trackSignedIn({ method: loginMethod });
}

getApolloClient()
  .query({ query: CurrentUserQuery })
  .then((res) => {
    identifyUser(res.data.current_user);
  })
  .catch(() => {
    // Anonymous (session pages / post-logout). If mixpanel still holds the
    // previous user's identity, drop it so their events aren't misattributed.
    if (!loginMethod && hasIdentifiedUser()) {
      resetAnalytics();
    }
  })
  .finally(() => {
    // Scheduled only after identity resolves/resets so the first page_viewed is
    // never attributed to a stale distinct_id (anonymous/post-logout boot whose
    // CurrentUserQuery rejects). The setTimeout(…, 0) still defers a tick so
    // router <Redirect>s (e.g. /admin → /admin/summary) settle and only the
    // final URL is tracked; SPA navigations come from AdminRouter's history listener.
    window.setTimeout(trackPageView, 0);
  });
